"use strict";
/**
 * @file Created on 02/14/2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var UserInfo_1 = require("../../user/model/UserInfo");

var ResourceLockType_1 = require("../enums/ResourceLockType");
/**
 * @author Jaroslav Sevcik
 */


var ResourceLockDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ResourceLockDTO, _DomainObject_1$Domai);

  /**
   * @param {List<UserInfo>} users
   * @param {string} resourceId
   * @param {ResourceLockType} resourceLockType
   */
  function ResourceLockDTO(users, resourceId, resourceLockType) {
    var _this;

    _classCallCheck(this, ResourceLockDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ResourceLockDTO).call(this));
    _this.users = users;
    _this.resourceId = resourceId;
    _this.resourceLockType = resourceLockType;
    return _this;
  }

  return ResourceLockDTO;
}(DomainObject_1.DomainObject);

exports.ResourceLockDTO = ResourceLockDTO;

ResourceLockDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(ResourceLockDTO.name);
  return {
    users: builder.listOf(builder.obj('users', UserInfo_1.UserInfo.schema, function (mat) {
      return new UserInfo_1.UserInfo(mat.id, mat.name);
    })),
    resourceId: builder.str('resourceId'),
    resourceLockType: builder.senum('resourceLockType', ResourceLockType_1.ResourceLockType, 'enums/ResourceLockType')
  };
}();